const createGeolocationCacheStore = (ttlMs) => {
    let entry = null;
    return {
        read: () => {
            if (!entry || Date.now() - entry.capturedAt >= ttlMs)
                return null;
            return entry.coords;
        },
        write: (coords) => {
            entry = { coords, capturedAt: Date.now() };
        },
        clear: () => {
            entry = null;
        }
    };
};
export default createGeolocationCacheStore;
